export enum PaymentMethodsActionType {
  CALCULATE = 'PAYMENT_METHODS/CALCULATE',
  CALCULATE_SUCCESS = 'PAYMENT_METHODS/CALCULATE_SUCCESS',
  CALCULATE_ERROR = 'PAYMENT_METHODS/CALCULATE_ERROR',
  CLEAN_CALCULATOR = 'PAYMENT_METHODS/CLEAN_CALCULATOR',
  GET_SELECTED_PAYMENT_METHOD = 'PAYMENT_METHODS/GET_SELECTED_PAYMENT_METHOD',
  GET_SELECTED_PAYMENT_METHOD_SUCCESS = 'PAYMENT_METHODS/GET_SELECTED_PAYMENT_METHOD_SUCCESS',
  GET_SELECTED_PAYMENT_METHOD_ERROR = 'PAYMENT_METHODS/GET_SELECTED_PAYMENT_METHOD_ERROR',
  GET_ALL_PAYMENT_METHODS = 'PAYMENT_METHODS/GET_ALL_PAYMENT_METHODS',
  GET_ALL_PAYMENT_METHODS_SUCCESS = 'PAYMENT_METHODS/GET_ALL_PAYMENT_METHODS_SUCCESS',
  GET_ALL_PAYMENT_METHODS_ERROR = 'PAYMENT_METHODS/GET_ALL_PAYMENT_METHODS_ERROR',
  ADD_PAYMENT_METHOD = 'PAYMENT_METHODS/ADD_PAYMENT_METHOD',
  ADD_PAYMENT_METHOD_SUCCESS = 'PAYMENT_METHODS/ADD_PAYMENT_METHOD_SUCCESS',
  ADD_PAYMENT_METHOD_ERROR = 'PAYMENT_METHODS/ADD_PAYMENT_METHOD_ERROR',
  DELETE_PAYMENT_METHOD = 'PAYMENT_METHODS/DELETE_PAYMENT_METHOD',
  DELETE_PAYMENT_METHOD_SUCCESS = 'PAYMENT_METHODS/DELETE_PAYMENT_METHOD_SUCCESS',
  DELETE_PAYMENT_METHOD_ERROR = 'PAYMENT_METHODS/DELETE_PAYMENT_METHOD_ERROR',
  EDIT_COVERAGE = 'PAYMENT_METHODS/EDIT_COVERAGE',
  SAVE_COVERAGE = 'PAYMENT_METHODS/SAVE_COVERAGE',
  SAVE_COVERAGE_SUCCESS = 'PAYMENT_METHODS/SAVE_COVERAGE_SUCCESS',
  SAVE_COVERAGE_ERROR = 'PAYMENT_METHODS/SAVE_COVERAGE_ERROR',
  GET_PAYMENT_METHODS_FILTER = 'PAYMENT_METHODS/GET_PAYMENT_METHODS_FILTER',
  GET_PAYMENT_METHODS_FILTER_SUCCESS = 'PAYMENT_METHODS/GET_PAYMENT_METHODS_FILTER_SUCCESS',
  GET_PAYMENT_METHODS_FILTER_ERROR = 'PAYMENT_METHODS/GET_PAYMENT_METHODS_FILTER_ERROR',
  GET_INSTALLMENTS_COUNTRY_INFOS = 'PAYMENT_METHODS/GET_INSTALLMENTS_COUNTRY_INFOS',
  GET_INSTALLMENTS_COUNTRY_INFOS_SUCCESS = 'PAYMENT_METHODS/GET_INSTALLMENTS_COUNTRY_INFOS_SUCCESS',
  GET_INSTALLMENTS_COUNTRY_INFOS_ERROR = 'PAYMENT_METHODS/GET_INSTALLMENTS_COUNTRY_INFOS_ERROR',
  ENABLE_INSTALLMENTS_COUNTRY = 'PAYMENT_METHODS/ENABLE_INSTALLMENTS_COUNTRY',
  ENABLE_INSTALLMENTS_COUNTRY_SUCCESS = 'PAYMENT_METHODS/ENABLE_INSTALLMENTS_COUNTRY_SUCCESS',
  ENABLE_INSTALLMENTS_COUNTRY_ERROR = 'PAYMENT_METHODS/ENABLE_INSTALLMENTS_COUNTRY_ERROR',
  DISABLE_INSTALLMENTS_COUNTRY = 'PAYMENT_METHODS/DISABLE_INSTALLMENTS_COUNTRY',
  DISABLE_INSTALLMENTS_COUNTRY_SUCCESS = 'PAYMENT_METHODS/DISABLE_INSTALLMENTS_COUNTRY_SUCCESS',
  DISABLE_INSTALLMENTS_COUNTRY_ERROR = 'PAYMENT_METHODS/DISABLE_INSTALLMENTS_COUNTRY_ERROR',
}

export const getSelectedPaymentMethods = (response: any) => ({
  type: PaymentMethodsActionType.GET_SELECTED_PAYMENT_METHOD,
  response,
});

export const getSelectedPaymentMethodsSuccess = (response: any) => ({
  type: PaymentMethodsActionType.GET_SELECTED_PAYMENT_METHOD_SUCCESS,
  response,
});

export const getSelectedPaymentMethodsError = (error: any) => ({
  type: PaymentMethodsActionType.GET_SELECTED_PAYMENT_METHOD_ERROR,
  error,
});

export const getAllPaymentMethods = (coutryFilter: string, page: number) => ({
  type: PaymentMethodsActionType.GET_ALL_PAYMENT_METHODS,
  coutryFilter,
  page,
});

export const getAllPaymentMethodsSuccess = (response: any) => ({
  type: PaymentMethodsActionType.GET_ALL_PAYMENT_METHODS_SUCCESS,
  response,
});

export const getAllPaymentMethodsError = (error: any) => ({
  type: PaymentMethodsActionType.GET_ALL_PAYMENT_METHODS_ERROR,
  error,
});

export const postAddPaymentMethod = (paymentMethodIds: number[]) => ({
  type: PaymentMethodsActionType.ADD_PAYMENT_METHOD,
  paymentMethodIds,
});

export const postAddPaymentMethodSuccess = (response: any) => ({
  type: PaymentMethodsActionType.ADD_PAYMENT_METHOD_SUCCESS,
  response,
});

export const postAddPaymentMethodError = (error: any) => ({
  type: PaymentMethodsActionType.ADD_PAYMENT_METHOD_ERROR,
  error,
});

export const deletePaymentMethod = (paymentMethodIds: number[]) => ({
  type: PaymentMethodsActionType.DELETE_PAYMENT_METHOD,
  paymentMethodIds,
});

export const deletePaymentMethodSuccess = (response: any) => ({
  type: PaymentMethodsActionType.DELETE_PAYMENT_METHOD_SUCCESS,
  response,
});

export const deletePaymentMethodError = (error: any) => ({
  type: PaymentMethodsActionType.DELETE_PAYMENT_METHOD_ERROR,
  error,
});

export const editCoverage = (show: boolean) => ({
  type: PaymentMethodsActionType.EDIT_COVERAGE,
  show,
});

export const saveCoverage = (currentSelection: string[], newSelection: string[]) => ({
  type: PaymentMethodsActionType.SAVE_COVERAGE,
  currentSelection,
  newSelection,
});

export const saveCoverageSuccess = (response: any) => ({
  type: PaymentMethodsActionType.SAVE_COVERAGE_SUCCESS,
  response,
});

export const saveCoverageError = (error: any) => ({
  type: PaymentMethodsActionType.SAVE_COVERAGE_ERROR,
  error,
});

export const calculate = payload => ({
  type: PaymentMethodsActionType.CALCULATE,
  amount: payload.amount,
  fromCurrency: payload.fromCurrency,
  toCurrency: payload.toCurrency,
  paymentMethod: payload.paymentMethod,
  country: payload.country,
  paymentMethodId: payload.paymentMethodId,
});

export const calculateSuccess = (response: any) => ({
  type: PaymentMethodsActionType.CALCULATE_SUCCESS,
  response,
});

export const calculateError = (error: any) => ({
  type: PaymentMethodsActionType.CALCULATE_ERROR,
  error,
});

export const cleanCalculator = () => ({
  type: PaymentMethodsActionType.CLEAN_CALCULATOR,
});

export const getPaymentMethodsFilter = (paymentType: string, country: string) => ({
  type: PaymentMethodsActionType.GET_PAYMENT_METHODS_FILTER,
  country,
  paymentType,
});

export const getPaymentMethodsFilterSuccess = (response: any) => ({
  type: PaymentMethodsActionType.GET_PAYMENT_METHODS_FILTER_SUCCESS,
  response,
});

export const getPaymentMethodsFilterError = (error: any) => ({
  type: PaymentMethodsActionType.GET_PAYMENT_METHODS_FILTER_ERROR,
  error,
});

export const getInstallmentsCountryInfos = () => ({
  type: PaymentMethodsActionType.GET_INSTALLMENTS_COUNTRY_INFOS,
});

export const getInstallmentsCountryInfosSuccess = (response: any) => ({
  type: PaymentMethodsActionType.GET_INSTALLMENTS_COUNTRY_INFOS_SUCCESS,
  response,
});

export const getInstallmentsCountryInfosError = (error: any) => ({
  type: PaymentMethodsActionType.GET_INSTALLMENTS_COUNTRY_INFOS_ERROR,
  error,
});

export const enableInstallmentsCountry = (country: string, payer: string) => ({
  type: PaymentMethodsActionType.ENABLE_INSTALLMENTS_COUNTRY,
  country,
  payer,
});

export const enableInstallmentsCountrySuccess = (country: string) => ({
  type: PaymentMethodsActionType.ENABLE_INSTALLMENTS_COUNTRY_SUCCESS,
  country,
});

export const enableInstallmentsCountryError = (error: any) => ({
  type: PaymentMethodsActionType.ENABLE_INSTALLMENTS_COUNTRY_ERROR,
  error,
});

export const disableInstallmentsCountry = (country: string, payer: string) => ({
  type: PaymentMethodsActionType.DISABLE_INSTALLMENTS_COUNTRY,
  country,
  payer,
});

export const disableInstallmentsCountrySuccess = (country: string) => ({
  type: PaymentMethodsActionType.DISABLE_INSTALLMENTS_COUNTRY_SUCCESS,
  country,
});

export const disableInstallmentsCountryError = (error: any) => ({
  type: PaymentMethodsActionType.DISABLE_INSTALLMENTS_COUNTRY_ERROR,
  error,
});
